"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body className="bg-zinc-950 text-zinc-100 antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="text-sm uppercase tracking-widest text-red-500">
            Error
          </p>
          <h1 className="text-2xl font-semibold">Something went wrong</h1>
          <p className="text-zinc-400">{error.message}</p>
          <button
            type="button"
            onClick={reset}
            className="rounded-md border border-zinc-700 px-4 py-2 text-sm hover:bg-zinc-900"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
